module.exports = __webpack_public_path__ + "img/consulta.60f925de.svg";